<template>
  <div
    class="d-flex flex-column justify-content-start align-item-center bg-lighter"
    style="min-height: 100vh"
  >
    <base-header class="header bg-primary mb-5">
      <div>
        <div class="row">
          <div class="col-lg-7 col-md-10 mt-lg-3 mb-lg-3">
            <breadcrumb
              :link="[{ name: 'Quản lý nhân viên', active: true }]"
              class="mt-3 mb-3 ml--3"
            ></breadcrumb>
            <h1 class="h1 text-white">Xin chào {{ info.name }}</h1>
            <p class="text-white">Đây là trang hồ sơ của bạn</p>
            <!-- <a href="#!" class="btn btn-info">Edit profile</a> -->
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <loading :active.sync="pending" :is-full-page="false"></loading>
      <div class="row">
        <div class="col-12">
          <card shadow>
            <div>
              <base-upload
                :preview="uploadPreview"
                @doUpload="doUpload"
              ></base-upload>
            </div>
            <div class="text-center">
              <h3>
                {{ info.username }}
                <br />
                <span class="font-weight-light">{{ info.name }}</span>
              </h3>
              <div class="h5 font-weight-300">
                <i class="ni location_pin mr-2"></i>
                {{ info.email }}
              </div>
            </div>
            <hr />
            <template>
              <ValidationObserver v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(saveProfile)">
                  <!-- <h6 class="heading-small text-muted mb-4">
                    Thông tin người dùng
                  </h6>-->
                  <div class>
                    <div class="row">
                      <div class="col-lg-4">
                        <base-input
                          readonly="true"
                          label="Tên đăng nhập"
                          placeholder="username"
                          v-model="info.username"
                        />
                      </div>
                      <div class="col-lg-4">
                        <base-input
                          type="password"
                          label="Mật khẩu"
                          placeholder="Để trống nếu không cần thay đổi mật khẩu"
                          v-model="info.password"
                        />
                      </div>
                      <div class="col-lg-4">
                        <base-input
                          input-classes="form-control-alternative"
                          label="Địa chỉ Email"
                          placeholder="jesse@example.com"
                          v-model="info.email"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <base-input
                            alternative
                            label="Tên hiển thị"
                            placeholder="Tên hiển thị"
                            input-classes="form-control-alternative"
                            v-model="info.name"
                            :error="errors[0]"
                            :valid="
                              errors.length == 0 &&
                                info.name &&
                                info.name.length > 0
                            "
                          />
                        </ValidationProvider>
                      </div>
                      <div class="col-lg-6">
                        <base-input
                          alternative
                          label="Số điện thoại"
                          placeholder="Số điện thoại"
                          input-classes="form-control-alternative"
                          v-model="info.phone"
                        />
                      </div>
                    </div>
                    <div class="d-flex flex-row-reverse">
                      <button
                        class="btn btn-primary"
                        @click.prevent="handleSubmit(saveProfile)"
                      >
                        Lưu lại
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { uploadService } from "@/_services";

export default {
  name: "user-profile",
  path: "/profile",
  data() {
    return {
      pending: false,
      uploadPreview: ""
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  mounted() {
    this.uploadPreview = this.$mediaURI + this.info.avatar;
  },
  methods: {
    ...mapActions("user", ["updateInfo"]),
    saveProfile() {
      this.pending = true;
      this.updateInfo(this.info)
        .then(res => {
          this.pending = false;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .catch(error => {
          this.pending = false;
          this.$alertify.error(error.message, {
            duration: 4000
          });
        });
    },
    doUpload(data, cb) {
      var self = this;
      this.uploadPreview = data.preview;
      uploadService.avatar({ file: data.file }).then(res => {
        self.info.avatar = res.data.path;
        cb();
        self.saveProfile();
      });
    }
  }
};
</script>
<style lang="scss">
.wrap-drop-img {
  height: 300px;
}
</style>
